import { createTextFilterContext } from "@/components/TextFilter/createTextFilterContext";

export const shiftsTextFilter = createTextFilterContext();

export const useEmployeeNameFilter = shiftsTextFilter.useFilter;
export const useEmployeeNameFilterActions = shiftsTextFilter.useFilterActions;
export const useShiftsFilterBannerItem = shiftsTextFilter.useFilterBannerItem;
